import React, { createContext, useContext, useMemo } from 'react';
import { useLocation } from 'react-router-dom';

import { getPageSectionFromPath } from './getPageSection';

type GtmAnalyticsContextValue = {
  pageSection: string;
};

const GtmAnalyticsContext = createContext<GtmAnalyticsContextValue | null>(
  null
);

type Props = {
  children: React.ReactNode;
};

/**
 * Opcional: expõe a seção atual derivada da rota para componentes que precisem
 * sobrescrever o default do pushGtmEvent.
 */
export function GtmAnalyticsProvider({ children }: Props): JSX.Element {
  const { pathname } = useLocation();
  const value = useMemo(
    () => ({ pageSection: getPageSectionFromPath(pathname) }),
    [pathname]
  );

  return (
    <GtmAnalyticsContext.Provider value={value}>
      {children}
    </GtmAnalyticsContext.Provider>
  );
}

export function useGtmPageSection(): string {
  const ctx = useContext(GtmAnalyticsContext);
  return ctx?.pageSection ?? getPageSectionFromPath();
}
